<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('form.name') }}</th>
          <th>{{ $tc('general.club') }}</th>
          <th>{{ $tc('seminar.positions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(p, index) in participants" :key="p.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ p.member ? `${p.member.firstName} ${p.member.lastName}` : '-' }}</td>
          <td>{{ p.club ? p.club.shortName : '-' }}</td>
          <td>{{ formatPositions(p.positions) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    participants: { type: Array, default: () => [] },
    showClubName: { type: Boolean, default: false }
  },

  methods: {
    formatPositions (positions) {
      if (!positions || !positions.length) return '-'
      return positions.map(p => this.$t('seminar.' + p)).join(', ')
    }
  }
}
</script>
